export default __webpack_public_path__ + "static/media/katie.54fe67b4.jpg";